import { useState, useEffect } from 'react';
import api from '../../api/axios';

// Signale, pendant la saisie, si le numéro appartient déjà à un fidèle.
// Simple avertissement : un parent peut inscrire son enfant avec son numéro.
export default function PhoneCheck({ phone, excludeId }) {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const digits = (phone || '').replace(/\D/g, '');
    if (digits.length < 8) { setResult(null); return; }
    const timer = setTimeout(() => {
      const params = { phone };
      if (excludeId) params.exclude = excludeId;
      api.get('/participants/check-phone/', { params, silentError: true })
        .then(res => setResult(res.data))
        .catch(() => setResult(null));
    }, 400);
    return () => clearTimeout(timer);
  }, [phone, excludeId]);

  if (!result) return null;
  if (!result.exists) {
    return <span style={{ display: 'block', marginTop: 4, fontSize: '0.76rem', color: '#16a34a' }}>✓ Nouveau numéro</span>;
  }
  return (
    <div style={{ marginTop: 6, padding: '8px 10px', borderRadius: 8, background: '#fffbeb', border: '1px solid #fcd34d', fontSize: '0.78rem', color: '#92400e' }}>
      <strong>Ce numéro existe déjà</strong>
      {result.matches.map(m => (
        <div key={m.id}>
          · <a href={`/participants/${m.id}`} target="_blank" rel="noreferrer" style={{ color: '#92400e', fontWeight: 600 }}>{m.full_name}</a> ({m.member_code}{m.church_name ? ` — ${m.church_name}` : ''})
        </div>
      ))}
      {result.other_churches > 0 && <div>· {result.other_churches} fiche(s) dans une autre église</div>}
      <div style={{ marginTop: 4 }}>Vérifiez qu'il ne s'agit pas de la même personne avant de créer la fiche (un parent peut partager son numéro avec son enfant).</div>
    </div>
  );
}
